import React from 'react';
import { Box, Row } from '../SubComponents/Modals';
import { Label } from '../SubComponents/Text';
import DurationOption from './DurationOption';
import styled from 'styled-components/macro';
import Loading from '../SubComponents/Loading';
import useLocalize from '../Hooks/useLocalize';

const OptionsContainer = styled(Row)`
  overflow-x: auto;
  &:before,
  &:after {
    content: '';
  }
`;

const defaultDurationOptions = [{ durationNumber: NaN }];

interface DurationProps {
  duration: number;
  durationOptions: { durationNumber: number; priceLow: number; priceHigh: number }[];
  boatCount: number;
  onChange: (duration: number) => void;
  enabled?: boolean;
  loading?: boolean;
  error?: string;
}

const Duration = ({
  duration,
  durationOptions,
  boatCount = 1,
  onChange,
  error,
  enabled = true,
  loading = false,
}: DurationProps) => {
  const localize = useLocalize();
  const options = durationOptions.length > 0 ? durationOptions : defaultDurationOptions;

  return (
    <Box flexDirection="column" p="0" mb="4" width="100%" error={error}>
      <Label px="12px" lineHeight="35px">
        {localize('product.durationInHours')}
      </Label>

      <Loading loading={loading}>
        <OptionsContainer justifyContent="space-between">
          {options.map((option) => {
            const optionProps = {
              option,
              selected: duration === option.durationNumber,
              onChange,
              enabled: enabled && !Number.isNaN(option.durationNumber),
              boatCount,
            };

            return <DurationOption {...optionProps} key={option.durationNumber} />;
          })}
        </OptionsContainer>
      </Loading>
    </Box>
  );
};

export default Duration;
